import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  CharterFilingService,
  type Wealthlane_CapTable_Dtos_CharterFiling_UpdateStockClassDetailsDto,
  type Wealthlane_Shared_Hosting_Dtos_GenericApiResponse,
} from '@wealthlane/api-services/wealthlane-captable-service';
import { type TableError } from '../../types/common';

const usePutStockClassDetails = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onClose?: () => void,
  onError?: (message: string, errors: TableError[]) => void
): UseMutationResult<
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined,
  unknown,
  Wealthlane_CapTable_Dtos_CharterFiling_UpdateStockClassDetailsDto,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation(
    async (payload: Wealthlane_CapTable_Dtos_CharterFiling_UpdateStockClassDetailsDto) => {
      return await handleRequest(
        CharterFilingService.putApiCapTableApiAppCharterFilingStockClassDetails(payload)
      );
    },
    {
      onSuccess: async () => {
        toast.success(
          <ToastComponent label='Success' message='Stock class details updated successfully.' />
        );
        await queryClient.invalidateQueries('getCharterStockClassList');
        await queryClient.invalidateQueries('getCharterFilings');
        onClose?.();
      },
      onError: (err: any) => {
        console.error('Update stock class details error', err);
        onError?.(err?.message, err?.errors);
        onClose?.();
      },
    }
  );
};

export default usePutStockClassDetails;
